import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/therapy-cosign-queue")({
  beforeLoad: ({ context }) => guardRoute(context.me, "therapy-cosign-queue"),
  component: Outlet,
});
